// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__2rsVC","content":"Footer_content__21wDB","menu":"Footer_menu__SZqCA","link":"Footer_link__30Zl6","text":"Footer_text__1ZXeu"};